export default "__VITE_ASSET__BigRT7gs__"